<div class="time-log-chart">
  <div class="chart-header">
    <div class="header-controls">
      <!-- Month Navigation -->
      <div class="month-nav">
        <button class="nav-btn" (click)="prevMonth()" pTooltip="Previous Month" tooltipPosition="top"><i
            class="pi pi-angle-left"></i></button>
        <span class="month-label" pTooltip="Current View: {{ month | date:'MMMM yyyy' }}" tooltipPosition="top">{{
          month | date:'MMMM yyyy' }}</span>
        <button class="nav-btn" (click)="nextMonth()" pTooltip="Next Month" tooltipPosition="top"><i
            class="pi pi-angle-right"></i></button>
        <button class="current-btn" *ngIf="!isCurrentMonth" (click)="currMonth()" pTooltip="Go to Current Month"
          tooltipPosition="top">Current month</button>
      </div>

      <div class="user-filter" *ngIf="showUserFilter">
        <p-dropdown [options]="users" [(ngModel)]="selectedUserId" optionLabel="label" optionValue="_id"
          placeholder="Filter by user" [showClear]="true" (onChange)="onUserSelect()" [style]="{'width':'200px'}"
          appendTo="body" [filter]="true" filterBy="label,firstName,lastName">
        </p-dropdown>
      </div>
    </div>
    <!-- Pages can place buttons before Total Time with a [chartActions] element. -->
    <div class="header-actions">
      <ng-content select="[chartActions]"></ng-content>
      <span class="total-time">Total Time: {{ totalLogged.toFixed(2) }}</span>
    </div>
  </div>
  <div class="chart-container">
    <div class="loading-overlay" *ngIf="loading">
      <p-progressSpinner strokeWidth="4" animationDuration=".5s"></p-progressSpinner>
    </div>
    <!-- Y Axis Labels -->
    <div class="y-axis">
      <div class="y-label" *ngFor="let tick of yAxisTicks">
        {{ tick }}
      </div>
    </div>

    <div class="chart-area">
      <!-- Grid Lines Background -->
      <div class="grid-lines">
        <div class="grid-line" *ngFor="let tick of yAxisTicks" [style.bottom.%]="(tick / maxHours) * 100"></div>
      </div>

      <!-- SVG Overlay for Required Line -->
      <svg class="chart-svg" preserveAspectRatio="none" viewBox="0 0 100 100">
        <path [attr.d]="requiredLinePath" fill="none" stroke="#fb923c" stroke-width="2" stroke-dasharray="4,4"
          vector-effect="non-scaling-stroke" />
      </svg>

      <!-- Bars Container -->
      <div class="bars-container">
        <div class="bar-column" *ngFor="let day of chartData; let i = index" [style.--i]="i" [class.today]="day.isToday"
          [class.weekend]="day.isWeekend">

          <!-- Hover Tooltip/Value -->
          <div class="bar-stack" style="cursor: pointer;" (click)="onBarClick(day)">
            <div class="bar-value-tooltip" *ngIf="getVisibleTotal(day) > 0"
              [style.bottom.%]="getBarHeight(getVisibleTotal(day))">
              <div class="tooltip-date">{{ day.date | date: 'dd/MM/yyyy' }}</div>
              <div class="tooltip-hours">Hours: {{ getVisibleTotal(day).toFixed(2) }}
                <span *ngIf="requiredHoursPerDay">({{ getPercentageOfRequired(getVisibleTotal(day)) }}%)</span>
              </div>
            </div>

            <!-- Value Label on Top (Static) -->
            <div class="bar-top-label" *ngIf="getVisibleTotal(day) > 0"
              [style.bottom.%]="getBarHeight(getVisibleTotal(day))">
              {{ getVisibleTotal(day).toFixed(2) }}
            </div>

            <!-- Non-Billable Bar (Top) -->
            <div class="bar non-billable" [style.height.%]="showNonBillable ? getBarHeight(day.nonBillable) : 0"
              [class.has-value]="day.nonBillable > 0">
            </div>

            <!-- Billable Bar (Bottom) -->
            <div class="bar billable" [style.height.%]="showBillable ? getBarHeight(day.billable) : 0"
              [class.has-value]="day.billable > 0">
            </div>
          </div>

          <!-- Labels -->
          <div class="x-axis-labels">
            <div class="day-letter">{{ day.day }}</div>
            <div class="date-number">{{ day.date | date: 'd' }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Legend -->
  <div class="chart-legend">
    <div class="legend-item clickable" (click)="toggleBillable()" [class.inactive]="!showBillable">
      <span class="legend-dot billable"></span>
      <span>Billable {{ showBillable ? totalBillable.toFixed(2) : '0.00' }}</span>
    </div>
    <div class="legend-item clickable" (click)="toggleNonBillable()" [class.inactive]="!showNonBillable">
      <span class="legend-dot non-billable"></span>
      <span>Non-billable {{ showNonBillable ? totalNonBillable.toFixed(2) : '0.00' }}</span>
    </div>
    <div class="legend-item">
      <span class="legend-line"></span>
      <span>Required {{ requiredTotal.toFixed(2) }}</span>
    </div>
  </div>

  <!-- Inline Time Log List -->
  <div class="inline-logs-wrapper mt-4" *ngIf="selectedDate">
    <div class="inline-logs-card">
      <div class="card-header">
        <h4 class="header-title">Time Logs for {{ selectedDate | date: 'fullDate' }}</h4>
        <button class="close-btn" (click)="selectedDate = null" pTooltip="Close" tooltipPosition="left" appendTo="body">
          <i class="pi pi-times"></i>
        </button>
      </div>
      <!-- Use shared components -->
      <app-time-logs-list *ngIf="selectedDate" [userId]="selectedUserId" [date]="selectedDate"
        [showLogMoreButton]="showLogTimeButton" [showEditButton]="showEditButton" [showDeleteButton]="showDeleteButton"
        (onEdit)="handleLogEdit($event)" (onUpdate)="refresh()"
        (onManualLogTime)="handleLogTime()"></app-time-logs-list>
    </div>
  </div>
</div>